
const AutomationToPartnershipSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1 flex justify-center">
              <img 
                src="/lovable-uploads/02675e5e-5f62-456f-8083-c0de99d53a8d.png"
                alt="Team collaboration in cybersecurity workspace"
                className="w-full h-auto rounded-2xl shadow-2xl max-w-lg"
              />
            </div>
            
            <div className="order-1 lg:order-2 space-y-8">
              <h2 className="text-4xl md:text-5xl font-bold leading-tight">
                Beyond Automation to 
                <span className="bg-gradient-to-r from-[#8932c8] to-[#b87ade] bg-clip-text text-transparent"> True Partnership</span>
              </h2>
              <div className="space-y-6">
                <p className="text-xl text-gray-700 leading-relaxed">
                  Many still think AI equals automation. A common question asked is, "How much of our SOC can we fully automate?" 
                  While this is tempting, handing off repetitive work to an automation engine without context can create as many 
                  problems as it solves.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  The future isn't about replacing analysts with fully automated environments. Instead, it's about making analysts 
                  that much better by pairing them with agentic AI. Aura XP shifts the conversation from execution to 
                  observation, learning, and collaboration.
                </p>
              </div>
              
              <div className="bg-gradient-to-r from-[#8932c8]/5 to-[#b87ade]/5 rounded-2xl p-8 border border-[#8932c8]/20">
                <div className="flex items-start gap-4">
                  <div>
                    <h4 className="font-bold text-[#8932c8] mb-3 text-lg">The Partnership Model</h4>
                    <p className="text-[#8932c8] text-lg">Unlike traditional playbooks, these agents are built to learn, adapt, and act autonomously. This is where the real transformation begins.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AutomationToPartnershipSection;
